import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/layout/PageHeader';
import { PromptForm } from '../components/prompts/PromptForm';
import { useCreatePrompt } from '../hooks/usePrompts';

export default function NewPromptPage() {
  const navigate = useNavigate();
  const createPrompt = useCreatePrompt();

  const handleSubmit = async (data: any) => {
    await createPrompt.mutateAsync(data);
    navigate('/prompts');
  };

  return (
    <div>
      <PageHeader
        title="Create Prompt"
        description="Create a new AI prompt template"
      />
      <div className="mt-6 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <PromptForm mode="create" onSubmit={handleSubmit} />
      </div>
    </div>
  );
}
